/**
 * Held items: vietnamese
 */
import * as THREE from 'three';

export function buildHeld_cap_tap(lib, itemGroup) {
  // CẶP TÁP CÔNG SỞ CẦM TAY (Held Briefcase)
  const briefMat = new THREE.MeshStandardMaterial({ color: '#1c1917', roughness: 0.4 });
  const goldMat = new THREE.MeshStandardMaterial({ color: '#f59e0b', metalness: 0.85, roughness: 0.2 });
  const handleMat = new THREE.MeshStandardMaterial({ color: '#292524', roughness: 0.7 });
  lib.disposables.push(briefMat, goldMat, handleMat);

  // Quai xách hình chữ U ở trên cùng (nằm vừa vặn trong bàn tay nhân vật)
  const handleGeo = new THREE.BoxGeometry(0.12, 0.05, 0.025);
  const handle = new THREE.Mesh(handleGeo, handleMat);
  handle.position.set(0, 0.02, 0);
  itemGroup.add(handle);

  // Thân cặp táp buông thẳng xuống dưới
  const briefGeo = new THREE.BoxGeometry(0.36, 0.28, 0.12);
  const brief = new THREE.Mesh(briefGeo, briefMat);
  brief.position.set(0, -0.16, 0);
  brief.castShadow = true;
  itemGroup.add(brief);

  // 2 Khóa bấm đồng vàng sang trọng
  [-0.09, 0.09].forEach((xOffset) => {
    const lockGeo = new THREE.BoxGeometry(0.035, 0.045, 0.02);
    const lock = new THREE.Mesh(lockGeo, goldMat);
    lock.position.set(xOffset, -0.14, 0.065);
    itemGroup.add(lock);
    lib.disposables.push(lockGeo);
  });

  lib.disposables.push(handleGeo, briefGeo);
}

export function buildHeld_clipboard(lib, itemGroup) {
  // BẢNG KẸP TÀI LIỆU CLIPBOARD STEAM CÓ BÚT BI & DÒNG KẺ CHECKLIST
  const boardMat = new THREE.MeshStandardMaterial({ color: '#78350f', roughness: 0.6 }); // Bìa gỗ cứng
  const clipMat = new THREE.MeshStandardMaterial({ color: '#cbd5e1', metalness: 0.9, roughness: 0.15 }); // Kẹp kim loại inox
  const penMat = new THREE.MeshStandardMaterial({ color: '#2563eb', roughness: 0.4 }); // Thân bút bi xanh
  const penTipMat = new THREE.MeshStandardMaterial({ color: '#e2e8f0', metalness: 0.95 }); // Ngòi bút
  lib.disposables.push(boardMat, clipMat, penMat, penTipMat);

  // Mặt bảng gỗ
  const boardGeo = new THREE.BoxGeometry(0.25, 0.34, 0.018);
  const board = new THREE.Mesh(boardGeo, boardMat);
  board.castShadow = true;
  itemGroup.add(board);

  // Tờ giấy A4 có in dòng kẻ và checklist
  const paperCanvas = document.createElement('canvas');
  paperCanvas.width = 256;
  paperCanvas.height = 340;
  const pCtx = paperCanvas.getContext('2d');
  pCtx.fillStyle = '#ffffff';
  pCtx.fillRect(0, 0, 256, 340);

  // Tiêu đề tài liệu
  pCtx.fillStyle = '#0f172a';
  pCtx.fillRect(24, 28, 140, 14);

  // 6 Dòng checklist kẻ ngang kèm ô vuông tích điểm
  const lineColors = ['#10b981', '#10b981', '#2563eb', '#64748b', '#64748b', '#64748b'];
  for (let i = 0; i < 6; i++) {
    const ly = 70 + i * 40;
    pCtx.strokeStyle = lineColors[i];
    pCtx.lineWidth = 3;
    pCtx.strokeRect(24, ly, 16, 16);
    if (i < 2) {
      pCtx.beginPath();
      pCtx.moveTo(27, ly + 8);
      pCtx.lineTo(32, ly + 14);
      pCtx.lineTo(38, ly + 4);
      pCtx.stroke();
    }
    pCtx.fillStyle = '#94a3b8';
    pCtx.fillRect(52, ly + 4, 180, 8);
  }

  const paperTex = new THREE.CanvasTexture(paperCanvas);
  paperTex.colorSpace = THREE.SRGBColorSpace;
  lib.disposables.push(paperTex);
  const paperMat = new THREE.MeshStandardMaterial({ map: paperTex, roughness: 0.9 });
  lib.disposables.push(paperMat);

  const paperGeo = new THREE.BoxGeometry(0.22, 0.3, 0.022);
  const paper = new THREE.Mesh(paperGeo, paperMat);
  paper.position.set(0, -0.01, 0.005);
  itemGroup.add(paper);

  // Kẹp inox lò xo phía trên
  const clipGeo = new THREE.BoxGeometry(0.1, 0.04, 0.035);
  const clip = new THREE.Mesh(clipGeo, clipMat);
  clip.position.set(0, 0.155, 0.012);
  itemGroup.add(clip);

  // Chiếc bút bi 3D cài ở mép kẹp
  const penBodyGeo = new THREE.CylinderGeometry(0.008, 0.008, 0.16, 8);
  const pen = new THREE.Mesh(penBodyGeo, penMat);
  pen.position.set(0.08, 0.12, 0.02);
  pen.rotation.z = -0.15;
  itemGroup.add(pen);

  const penTipGeo = new THREE.ConeGeometry(0.008, 0.02, 8);
  const penTip = new THREE.Mesh(penTipGeo, penTipMat);
  penTip.position.set(0.08 + 0.012, 0.03, 0.02);
  penTip.rotation.z = Math.PI - 0.15;
  itemGroup.add(penTip);

  // Xoay góc tự nhiên
  itemGroup.rotation.set(0.25, 0, 0.15);
  lib.disposables.push(boardGeo, paperGeo, clipGeo, penBodyGeo, penTipGeo);
}

export function buildHeld_ganh_hang_rong(lib, itemGroup) {
  // ĐÒN GÁNH TRE & ĐÔI THÚNG MÂY HOA QUẢ VIỆT NAM (Street Hawker Baskets)
  const bambooMat = new THREE.MeshStandardMaterial({ color: '#ca8a04', roughness: 0.6 }); // Tre vàng dẻo dai
  const basketMat = new THREE.MeshStandardMaterial({ color: '#78350f', roughness: 0.85 }); // Mây tre đan
  const ropeMat = new THREE.MeshStandardMaterial({ color: '#a16207', roughness: 0.9 }); // Dây quang mây
  const bananaMat = new THREE.MeshStandardMaterial({ color: '#facc15', roughness: 0.6 }); // Chuối chín vàng
  const comMat = new THREE.MeshStandardMaterial({ color: '#22c55e', roughness: 0.8 }); // Gói cốm xanh lá sen
  lib.disposables.push(bambooMat, basketMat, ropeMat, bananaMat, comMat);

  // Đòn gánh tre uốn cong
  const poleGeo = new THREE.BoxGeometry(0.04, 0.035, 1.25);
  const pole = new THREE.Mesh(poleGeo, bambooMat);
  pole.position.set(0, 0, 0);
  itemGroup.add(pole);

  // 2 Đầu đòn gánh có cụm 3 dây quang mây tre đan tỏa đều hình nón xuống vành thúng
  [-0.52, 0.52].forEach((pz) => {
    const basketGeo = new THREE.CylinderGeometry(0.24, 0.19, 0.16, 8);
    const basket = new THREE.Mesh(basketGeo, basketMat);
    basket.position.set(0, -0.58, pz);
    basket.castShadow = true;
    itemGroup.add(basket);

    // 3 Dây quang mây nối từ đầu đòn gánh xuống 3 điểm xung quanh vành thúng (góc 120 độ)
    const topY = -0.02;
    const basketRimY = -0.5;
    const rimRadius = 0.22;
    const angles = [0, (2 * Math.PI) / 3, (4 * Math.PI) / 3];

    angles.forEach((ang) => {
      const bx = Math.sin(ang) * rimRadius;
      const bz = pz + Math.cos(ang) * rimRadius;

      const startPt = new THREE.Vector3(0, topY, pz);
      const endPt = new THREE.Vector3(bx, basketRimY, bz);
      const dir = new THREE.Vector3().subVectors(endPt, startPt);
      const cordLen = dir.length();
      const midPt = new THREE.Vector3().addVectors(startPt, endPt).multiplyScalar(0.5);

      const cordGeo = new THREE.CylinderGeometry(0.008, 0.008, cordLen, 6);
      const cord = new THREE.Mesh(cordGeo, ropeMat);
      cord.position.copy(midPt);
      cord.quaternion.setFromUnitVectors(new THREE.Vector3(0, 1, 0), dir.clone().normalize());
      itemGroup.add(cord);
      lib.disposables.push(cordGeo);
    });

    for (let b = 0; b < 3; b++) {
      const bGeo = new THREE.BoxGeometry(0.06, 0.04, 0.14);
      const banana = new THREE.Mesh(bGeo, bananaMat);
      banana.position.set((b - 1) * 0.07, -0.48, pz + (b % 2 === 0 ? 0.03 : -0.03));
      banana.rotation.y = (b - 1) * 0.3;
      itemGroup.add(banana);
      lib.disposables.push(bGeo);
    }

    const comGeo = new THREE.BoxGeometry(0.12, 0.06, 0.12);
    const com = new THREE.Mesh(comGeo, comMat);
    com.position.set(0, -0.46, pz);
    itemGroup.add(com);

    lib.disposables.push(basketGeo, comGeo);
  });

  lib.disposables.push(poleGeo);
}

export function buildHeld_am_tra_bat_trang(lib, itemGroup) {
  // ẤM TRÀ GỐM BÁT TRÀNG QUẤN VẢI GIỮ NHIỆT (Sidewalk Teapot)
  const ceramicMat = new THREE.MeshStandardMaterial({ color: '#047857', roughness: 0.35, metalness: 0.2 }); // Men ngọc Bát Tràng
  const wrapMat = new THREE.MeshStandardMaterial({ color: '#ea580c', roughness: 0.9 }); // Vải đỏ bọc giữ nhiệt
  const copperMat = new THREE.MeshStandardMaterial({ color: '#b45309', metalness: 0.9, roughness: 0.3 }); // Quai đồng
  lib.disposables.push(ceramicMat, wrapMat, copperMat);

  const bodyGeo = new THREE.CylinderGeometry(0.12, 0.14, 0.22, 12);
  const body = new THREE.Mesh(bodyGeo, ceramicMat);
  body.castShadow = true;
  itemGroup.add(body);

  const wrapGeo = new THREE.CylinderGeometry(0.142, 0.142, 0.14, 12);
  const wrap = new THREE.Mesh(wrapGeo, wrapMat);
  wrap.position.set(0, -0.02, 0);
  itemGroup.add(wrap);

  const lidGeo = new THREE.CylinderGeometry(0.08, 0.11, 0.05, 12);
  const lid = new THREE.Mesh(lidGeo, ceramicMat);
  lid.position.set(0, 0.13, 0);
  itemGroup.add(lid);

  const knobGeo = new THREE.BoxGeometry(0.035, 0.035, 0.035);
  const knob = new THREE.Mesh(knobGeo, copperMat);
  knob.position.set(0, 0.165, 0);
  itemGroup.add(knob);

  const spoutGeo = new THREE.BoxGeometry(0.045, 0.12, 0.045);
  const spout = new THREE.Mesh(spoutGeo, ceramicMat);
  spout.position.set(0.14, 0.05, 0);
  spout.rotation.z = -0.55;
  itemGroup.add(spout);

  const handleGeo = new THREE.TorusGeometry(0.12, 0.012, 6, 16, Math.PI);
  const handle = new THREE.Mesh(handleGeo, copperMat);
  handle.position.set(0, 0.16, 0);
  itemGroup.add(handle);

  lib.disposables.push(bodyGeo, wrapGeo, lidGeo, knobGeo, spoutGeo, handleGeo);
}

export function buildHeld_coc_tra_da(lib, itemGroup) {
  // CỐC TRÀ ĐÁ THỦY TINH XANH BỌT VỈA HÈ HÀ NỘI
  const glassMat = new THREE.MeshPhysicalMaterial({
    color: 0x67e8f9,
    transparent: true,
    opacity: 0.5,
    roughness: 0.1
  });
  const teaMat = new THREE.MeshStandardMaterial({ color: '#d97706', roughness: 0.4 }); // Trà màu vàng hổ phách
  const iceMat = new THREE.MeshPhysicalMaterial({
    color: 0xffffff,
    transparent: true,
    opacity: 0.8,
    roughness: 0.05
  });
  const lemonMat = new THREE.MeshStandardMaterial({ color: '#facc15', roughness: 0.5 }); // Lát chanh vàng
  lib.disposables.push(glassMat, teaMat, iceMat, lemonMat);

  const cupGeo = new THREE.CylinderGeometry(0.075, 0.06, 0.19, 12);
  const cup = new THREE.Mesh(cupGeo, glassMat);
  itemGroup.add(cup);

  const teaGeo = new THREE.CylinderGeometry(0.068, 0.055, 0.16, 12);
  const tea = new THREE.Mesh(teaGeo, teaMat);
  tea.position.set(0, -0.01, 0);
  itemGroup.add(tea);

  [
    [-0.02, 0.05, 0],
    [0.02, 0.06, 0.02],
    [0, 0.04, -0.02]
  ].forEach(([ix, iy, iz]) => {
    const iceGeo = new THREE.BoxGeometry(0.035, 0.035, 0.035);
    const ice = new THREE.Mesh(iceGeo, iceMat);
    ice.position.set(ix, iy, iz);
    itemGroup.add(ice);
    lib.disposables.push(iceGeo);
  });

  const lemonGeo = new THREE.CylinderGeometry(0.04, 0.04, 0.01, 10);
  const lemon = new THREE.Mesh(lemonGeo, lemonMat);
  lemon.rotation.x = Math.PI / 2;
  lemon.position.set(0.065, 0.085, 0);
  itemGroup.add(lemon);

  lib.disposables.push(cupGeo, teaGeo, lemonGeo);
}

export function buildHeld_binh_giu_nhiet(lib, itemGroup) {
  // BÌNH GIỮ NHIỆT GEN Z / DÂN VĂN PHÒNG CHUẨN VOXEL (Màu pastel, nắp vặn kim loại, quai xách)
  const bottleMat = new THREE.MeshStandardMaterial({ color: '#38bdf8', roughness: 0.35, metalness: 0.1 });
  const rubberMat = new THREE.MeshStandardMaterial({ color: '#0284c7', roughness: 0.8 });
  const capMat = new THREE.MeshStandardMaterial({ color: '#e2e8f0', metalness: 0.85, roughness: 0.2 });
  const strapMat = new THREE.MeshStandardMaterial({ color: '#64748b', roughness: 0.6 });
  lib.disposables.push(bottleMat, rubberMat, capMat, strapMat);

  // Thân bình nước trụ tròn
  const bodyGeo = new THREE.CylinderGeometry(0.062, 0.062, 0.26, 12);
  const body = new THREE.Mesh(bodyGeo, bottleMat);
  body.position.set(0, 0, 0);
  body.castShadow = true;
  itemGroup.add(body);

  // Vòng đệm cao su silicon chống trơn giữa thân
  const bandGeo = new THREE.CylinderGeometry(0.065, 0.065, 0.06, 12);
  const band = new THREE.Mesh(bandGeo, rubberMat);
  band.position.set(0, 0.01, 0);
  itemGroup.add(band);

  // Cổ bình & nắp xoay kim loại
  const capGeo = new THREE.CylinderGeometry(0.055, 0.058, 0.06, 12);
  const cap = new THREE.Mesh(capGeo, capMat);
  cap.position.set(0, 0.15, 0);
  itemGroup.add(cap);

  // Quai xách gập chữ U
  const handleGeo = new THREE.BoxGeometry(0.02, 0.06, 0.06);
  const handle = new THREE.Mesh(handleGeo, strapMat);
  handle.position.set(0.045, 0.18, 0);
  itemGroup.add(handle);

  lib.disposables.push(bodyGeo, bandGeo, capGeo, handleGeo);
}

export function buildHeld_dui_cui_giao_thong(lib, itemGroup) {
  // GẬY / DÙI CUI ĐIỀU TIẾT GIAO THÔNG PHẢN QUANG (Bảo vệ phân luồng)
  const gripMat = new THREE.MeshStandardMaterial({ color: '#18181b', roughness: 0.8 });
  const redMat = new THREE.MeshStandardMaterial({ color: '#ef4444', roughness: 0.3 });
  const whiteMat = new THREE.MeshStandardMaterial({ color: '#f8fafc', roughness: 0.3 });
  const tipMat = new THREE.MeshBasicMaterial({ color: '#facc15' });
  lib.disposables.push(gripMat, redMat, whiteMat, tipMat);

  // Cán tay cầm cao su đen
  const gripGeo = new THREE.CylinderGeometry(0.024, 0.024, 0.14, 8);
  const grip = new THREE.Mesh(gripGeo, gripMat);
  grip.position.set(0, -0.15, 0);
  itemGroup.add(grip);

  // Thân gậy chia 4 đoạn sọc phản quang đỏ/trắng
  const stripes = [
    { y: -0.03, mat: redMat },
    { y: 0.07, mat: whiteMat },
    { y: 0.17, mat: redMat },
    { y: 0.27, mat: whiteMat }
  ];
  stripes.forEach((s) => {
    const segGeo = new THREE.CylinderGeometry(0.028, 0.028, 0.09, 8);
    const seg = new THREE.Mesh(segGeo, s.mat);
    seg.position.set(0, s.y, 0);
    itemGroup.add(seg);
    lib.disposables.push(segGeo);
  });

  // Đầu chóp gậy phát sáng
  const tipGeo = new THREE.CylinderGeometry(0.022, 0.028, 0.03, 8);
  const tip = new THREE.Mesh(tipGeo, tipMat);
  tip.position.set(0, 0.33, 0);
  itemGroup.add(tip);

  lib.disposables.push(gripGeo, tipGeo);
}

export function buildHeld_dien_thoai_smartphone(lib, itemGroup) {
  // ĐIỆN THOẠI SMARTPHONE CÔNG NGHỆ (Màn hình app bản đồ & nhận đơn)
  const phoneCaseMat = new THREE.MeshStandardMaterial({ color: '#09090b', roughness: 0.4, metalness: 0.7 });
  const screenMat = new THREE.MeshStandardMaterial({ color: '#0284c7', roughness: 0.1 });
  const mapLineMat = new THREE.MeshBasicMaterial({ color: '#22c55e' });
  const camMat = new THREE.MeshStandardMaterial({ color: '#27272a', metalness: 0.9, roughness: 0.1 });
  lib.disposables.push(phoneCaseMat, screenMat, mapLineMat, camMat);

  // Thân điện thoại siêu mỏng
  const phoneGeo = new THREE.BoxGeometry(0.12, 0.24, 0.016);
  const phone = new THREE.Mesh(phoneGeo, phoneCaseMat);
  phone.castShadow = true;
  itemGroup.add(phone);

  // Màn hình sáng
  const screenGeo = new THREE.BoxGeometry(0.105, 0.21, 0.005);
  const screen = new THREE.Mesh(screenGeo, screenMat);
  screen.position.set(0, 0, 0.009);
  itemGroup.add(screen);

  // Vạch đường lộ trình giao hàng xanh lá trên map
  const lineGeo = new THREE.BoxGeometry(0.06, 0.02, 0.006);
  const line = new THREE.Mesh(lineGeo, mapLineMat);
  line.position.set(0, 0.03, 0.011);
  line.rotation.z = 0.4;
  itemGroup.add(line);

  // Cụm 3 mắt camera sau
  const camGeo = new THREE.BoxGeometry(0.045, 0.045, 0.006);
  const cam = new THREE.Mesh(camGeo, camMat);
  cam.position.set(0.025, 0.075, -0.009);
  itemGroup.add(cam);

  lib.disposables.push(phoneGeo, screenGeo, lineGeo, camGeo);
}

export function buildHeld_cap_tai_lieu_bds(lib, itemGroup) {
  // KẸP TÀI LIỆU QUY HOẠCH BĐS / SỔ HỌP CÁN BỘ (Bìa da kẹp bản đồ)
  const leatherMat = new THREE.MeshStandardMaterial({ color: '#581c87', roughness: 0.5 }); // Bìa tím thẫm sang trọng
  const paperWhiteMat = new THREE.MeshStandardMaterial({ color: '#f8fafc', roughness: 0.8 });
  const redZoneMat = new THREE.MeshStandardMaterial({ color: '#ef4444', roughness: 0.7 }); // Vùng đất quy hoạch đỏ
  const greenZoneMat = new THREE.MeshStandardMaterial({ color: '#22c55e', roughness: 0.7 });
  lib.disposables.push(leatherMat, paperWhiteMat, redZoneMat, greenZoneMat);

  // Bìa kẹp tài liệu
  const folderGeo = new THREE.BoxGeometry(0.32, 0.24, 0.04);
  const folder = new THREE.Mesh(folderGeo, leatherMat);
  folder.castShadow = true;
  itemGroup.add(folder);

  // Xấp giấy tài liệu kẹp bên trong
  const paperGeo = new THREE.BoxGeometry(0.3, 0.22, 0.02);
  const paper = new THREE.Mesh(paperGeo, paperWhiteMat);
  paper.position.set(0.01, 0, 0.015);
  itemGroup.add(paper);

  // Mảng màu bản đồ quy hoạch
  const redZGeo = new THREE.BoxGeometry(0.12, 0.08, 0.022);
  const redZ = new THREE.Mesh(redZGeo, redZoneMat);
  redZ.position.set(-0.04, 0.03, 0.016);
  itemGroup.add(redZ);

  const grnZGeo = new THREE.BoxGeometry(0.1, 0.09, 0.022);
  const grnZ = new THREE.Mesh(grnZGeo, greenZoneMat);
  grnZ.position.set(0.06, -0.02, 0.016);
  itemGroup.add(grnZ);

  lib.disposables.push(folderGeo, paperGeo, redZGeo, grnZGeo);
}

export function buildHeld_hop_co_khi_sua_xe(lib, itemGroup) {
  // HỘP ĐỒ NGHỀ CƠ KHÍ SỬA XE MÁY (Hộp sắt dính dầu mỡ, cờ-lê mỏ-lết)
  const ironMat = new THREE.MeshStandardMaterial({ color: '#1e3a8a', roughness: 0.6, metalness: 0.5 }); // Sơn xanh cơ khí
  const latchMat = new THREE.MeshStandardMaterial({ color: '#f59e0b', metalness: 0.9, roughness: 0.2 });
  const wrenchMat = new THREE.MeshStandardMaterial({ color: '#cbd5e1', metalness: 0.85, roughness: 0.2 });
  lib.disposables.push(ironMat, latchMat, wrenchMat);

  // Thùng đồ nghề chính
  const boxGeo = new THREE.BoxGeometry(0.34, 0.2, 0.2);
  const box = new THREE.Mesh(boxGeo, ironMat);
  box.castShadow = true;
  itemGroup.add(box);

  // Quai xách sắt trên nắp
  const handleGeo = new THREE.BoxGeometry(0.16, 0.04, 0.02);
  const handle = new THREE.Mesh(handleGeo, ironMat);
  handle.position.set(0, 0.12, 0);
  itemGroup.add(handle);

  // 2 Khóa cài kim loại
  [-0.08, 0.08].forEach((lx) => {
    const latchGeo = new THREE.BoxGeometry(0.03, 0.05, 0.02);
    const latch = new THREE.Mesh(latchGeo, latchMat);
    latch.position.set(lx, 0.02, 0.105);
    itemGroup.add(latch);
    lib.disposables.push(latchGeo);
  });

  // Cờ-lê thò nhẹ ra ngoài nắp
  const wrenchGeo = new THREE.BoxGeometry(0.03, 0.16, 0.015);
  const wrench = new THREE.Mesh(wrenchGeo, wrenchMat);
  wrench.position.set(0.09, 0.08, 0.09);
  wrench.rotation.z = -0.3;
  itemGroup.add(wrench);

  lib.disposables.push(boxGeo, handleGeo, wrenchGeo);
}

export const vietnamese_held_builders = {
  cap_tap: buildHeld_cap_tap,
  clipboard: buildHeld_clipboard,
  ganh_hang_rong: buildHeld_ganh_hang_rong,
  am_tra_bat_trang: buildHeld_am_tra_bat_trang,
  coc_tra_da: buildHeld_coc_tra_da,
  binh_giu_nhiet: buildHeld_binh_giu_nhiet,
  dui_cui_giao_thong: buildHeld_dui_cui_giao_thong,
  dien_thoai_smartphone: buildHeld_dien_thoai_smartphone,
  cap_tai_lieu_bds: buildHeld_cap_tai_lieu_bds,
  hop_co_khi_sua_xe: buildHeld_hop_co_khi_sua_xe
};
